import React, {useEffect, useState} from "react";
import {Label, FormGroup, Modal} from "reactstrap";
import {AvField, AvForm} from "availity-reactstrap-validation";
import {Input, Alert} from "antd";
import {connect} from "react-redux";
import {getTransaction, refundPayment} from "../../store/transactions/actions";
import {toEUR} from "helpers/currency";

const Refund = ({data, isNewBookingModalOpen, isLoading, onCancel, refundPayment, getTransaction, transactionList}) => {
  const [refund, setRefund] = useState(data)
  const [error, setError] = useState('')
  // Prices are stored in BGN, but Stripe refunds are issued in EUR: the admin types EUR.
  const maxRefundEUR = toEUR(Number(refund.currentPrice) - Number(transactionList?.refundPrice || 0))

  useEffect(() => {
    getTransaction({bookingId: refund.id, stripePaymentId: refund.stripePaymentID})
    // eslint-disable-next-line react-hooks/exhaustive-deps -- fetch only once on mount using the initial `refund` (from the `data` prop); re-running on every `refund` update would refetch on every keystroke.
  }, [])

  useEffect(() => {
    if (!error) return
    const timeoutId = setTimeout(() => {
      setError('')
    }, 5000)
    return () => clearTimeout(timeoutId)
  }, [error])
  const handleChange = ({target}) => {
    const {name, value} = target;
    setRefund({...refund, [name]: value});
  }
  const refundTransaction = (e) => {
    e.preventDefault()
    let errorMessage = ''
    if(isNaN(Number(refund.price)) || Number(refund.price) <= 0 || Number(Number(refund.price).toFixed(2)) > maxRefundEUR) {
      errorMessage = 'Сумата за възстановяване трябва да е положително число и да не надвишава цената!'
    } else if(!refund.stripePaymentID) {
      errorMessage = 'Възникна грешка — липсва Stripe ID!'
    } else if(refund.description.length < 3) {
      errorMessage = 'Описанието трябва да е поне 3 символа!'
    }
    if(!errorMessage) {
      refundPayment({amount: refund.price, transactionId: transactionList.transactionId})
      onCancel()
      return
    }
    setError(errorMessage)
  }
  return (
    <Modal isOpen={isNewBookingModalOpen} toggle={onCancel}>
      <div className="modal-header">
        {error && <Alert
          className="position-fixed t-1 l-1 z-index-1"
          message="Грешка"
          description={error}
          type="error"
          showIcon
        />}
        <h5 className="modal-title mt-0">Възстановяване</h5>
        <button
          type="button"
          onClick={onCancel}
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
        <AvForm className="needs-validation">
          <FormGroup>
            <Label htmlFor="validationCustom01">Възстановяване / макс. сума за възстановяване {maxRefundEUR.toFixed(2)} €</Label>
            <Input
              name="price"
              placeholder="Възстановяване"
              type="text"
              suffix="EUR"
              onChange={handleChange}
              value={refund.price}
              validate={{required: {value: true}}}
              id={refund.id}
            />
          </FormGroup>
          {/*<FormGroup>*/}
          {/*  <Label htmlFor="validationCustom02">Reason</Label>*/}
          {/*  <Select*/}
          {/*    className="w-100"*/}
          {/*    value={refund.reason}*/}
          {/*    placeholder="Select Reason"*/}
          {/*    onChange={(e) => handleChange({target: {value: e, name: 'reason', id: refund.id}})}*/}
          {/*  >*/}
          {/*    <Option value="" disabled>Select Reason</Option>*/}
          {/*    <Option value="duplicate">Duplicate</Option>*/}
          {/*    <Option value="fraudulent">Fraudulent</Option>*/}
          {/*    <Option value="requested_by_customer">Requested by customer</Option>*/}
          {/*    <Option value="other">Other</Option>*/}
          {/*  </Select>*/}
          {/*</FormGroup>*/}
          {<FormGroup>
            <AvField
              name="description"
              placeholder={"Каква е причината за възстановяването?"}
              type="textarea"
              rows={3}
              minLength="3"
              className="form-control"
              onChange={handleChange}
              value={refund.description}
            />
          </FormGroup>}
        </AvForm>
      </div>

      {isLoading && (
        <div className="modal-footer">
          <div className="spinner-border text-success m-1" role="status">
            <span className="sr-only">Зареждане...</span>
          </div>
        </div>
      )}

      {!isLoading && (
        <div className="modal-footer d-flex align-content-end">
          <button
            type="button"
            onClick={onCancel}
            className="btn btn-secondary waves-effect"
            data-dismiss="modal"
          >
            Отказ
          </button>
          <button
            type="button"
            onClick={refundTransaction}
            className="btn btn-primary waves-effect waves-light justify-content-center d-flex"
          >
            <i className='bx bx-undo font-size-18'></i> Възстанови
          </button>
        </div>
      )}
    </Modal>
  );
}
const mapStateToProps = (state) => {
  const {Transactions} = state;
  return Transactions;
};

export default connect(mapStateToProps, {
  refundPayment,
  getTransaction
})(Refund);
